import script from "./particulars.vue?vue&type=script&setup=true&lang=js"
export * from "./particulars.vue?vue&type=script&setup=true&lang=js"

import "./particulars.vue?vue&type=style&index=0&id=5e7aaa24&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e7aaa24"]])

export default __exports__